import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';

import * as sha1 from 'js-sha1';

import * as _ from 'lodash'


import { ReponseWebService } from '../datastruct/Meloyi.module';



const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};



@Injectable({
  providedIn: 'root'
})
export class DashboardserviceService {
											   
  baseUrlRem1 = "https://dkm.sentelecom.com/gestion/" ;

  constructor(private http: HttpClient) { }



  loadRecouvrementBoutique(samacaabiyoonwii: string, idboutique, debut, fin ): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, boutique:idboutique, date_debut: debut, date_fin:fin} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.baseUrlRem1+'recouvrement_par_boutique.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }

  loadClientsDormant(samacaabiyoonwii: string, idboutique, debut, fin ): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, boutique:idboutique, date_debut: debut, date_fin:fin} ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;

	    this.remotelogger(this.baseUrlRem1+'getClientsDormant.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getStockStats(samacaabiyoonwii: string, idboutique, debut, fin ): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, boutique:idboutique, date_debut: debut, date_fin:fin} ; 

		console.log(postData);
		 
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.baseUrlRem1+'getStockStats.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getFinanceStats(samacaabiyoonwii: string, idboutique, debut, fin ): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, boutique:idboutique, date_debut: debut, date_fin:fin} ; 

		console.log(postData);
		 
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.baseUrlRem1+'getFinanceStats.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }

  getTopBottomProfitProducts(samacaabiyoonwii: string, idboutique, debut, fin ): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, boutique:idboutique, date_debut: debut, date_fin:fin} ; 

		console.log(postData);
		 
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.baseUrlRem1+'getTopBottomProfitProducts.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getProduitsDormant(samacaabiyoonwii: string, idboutique, debut, fin ): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, boutique:idboutique, date_debut: debut, date_fin:fin} ; 

		console.log(postData);
		 
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.baseUrlRem1+'getProduitsDormant.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getProduitsCritiques(samacaabiyoonwii: string, idboutique, debut, fin ): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, boutique:idboutique, date_debut: debut, date_fin:fin} ; 

		console.log(postData);
		 
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.baseUrlRem1+'getProduitsCritiques.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getTMostSaledProducts(samacaabiyoonwii: string, idboutique, debut, fin ): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, boutique:idboutique, date_debut: debut, date_fin:fin} ; 

		console.log(postData);
		 
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.baseUrlRem1+'getTMostSaledProducts.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }
  
  getTopLeastSaledProducts(samacaabiyoonwii: string, idboutique, debut, fin ): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, boutique:idboutique, date_debut: debut, date_fin:fin} ; 

		console.log(postData);
		 
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.baseUrlRem1+'getTopLeastSaledProducts.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }

  getTopMostRentableProducts(samacaabiyoonwii: string, idboutique, debut, fin ): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, boutique:idboutique, date_debut: debut, date_fin:fin} ; 

		console.log(postData);
		 
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.baseUrlRem1+'getTopMostRentableProducts.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }



  remotelogger(url: string, sentData: any) {
    return this.http.post<ReponseWebService>(url, sentData, httpOptions);
  }


}
